export function navigate(to: string) {
  window.location.replace(to);
}
